import {
  districtColumns,
  talukaColumns,
  areaTypeColumns,
  phcColumns,
  subCenterColumns,
  bankColumns,
  villageColumns,
  roleColumns,
  userColumns,
  trainingColumns,
  facultyColumns,
  trainingCalendarColumns,
  programColumns,
  schemeColumns,
  activityColumns,
  bankBranchColumns,
  governingbodyColumns,
  corporationColumns,
  uphcColumns,
  subareaColumns,
} from './MasterTableConstants';
import UserRoles from './UserRoles';
export const MASTER_VIEW_CONFIG = {
  areaTypeMaster: {
    /**If you want to show Add Button in Master View then give user roles */
    /**If Array is empty then button will not show */
    showAddButton: [],
    showUpdateButton: [],
    showDeleteButton: [],
    tableConfig: {
      columns: areaTypeColumns,
      dataKey: 'areaTypeId',
      dataName: 'areaTypeName',
      filterMethodsConfig: {
        areaCode: 'search',
        areaTypeName: 'dropdown',
        areaCategoryName: 'dropdown',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },

  districtMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: districtColumns,
      dataKey: 'districtId',
      dataName: 'districtName',
      filterMethodsConfig: {
        districtCode: 'search',
        districtName: 'search',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },
  talukaMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: talukaColumns,
      dataKey: 'talukaId',
      dataName: 'talukaName',
      filterMethodsConfig: {
        talukaCode: 'search',
        talukaName: 'search',
        districtName: 'search',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },
  localgoverningbodymaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: governingbodyColumns,
      dataKey: 'lgbId',
      dataName: 'lgbName',
      filterMethodsConfig: {
        lgbIdCode: 'search',
        lgbName: 'search',
        areaType: 'dropdown',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },
  corporation_coucil_master: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: corporationColumns,
      dataKey: 'corporation_council_id',
      dataName: 'corporation_council_code',
      filterMethodsConfig: {
        corporation_council_code: 'search',
        corporation_council_id: 'search',
        talukaName: 'search',
        districtName: 'search',
        lgbName: 'search',
        areaType: 'dropdown',
        areaCategory: 'dropdown',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },
  phcMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: phcColumns,
      dataKey: 'phcId',
      dataName: 'phcName',
      filterMethodsConfig: {
        phcCode: 'search',
        phcName: 'search',
        talukaName: 'search',
        areaType: 'dropdown',
        areaCategory: 'dropdown',
        districtName: 'search',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },
  uphcMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: uphcColumns,
      dataKey: 'phcId',
      dataName: 'phcName',
      filterMethodsConfig: {
        phcCode: 'search',
        phcName: 'search',
        talukaName: 'search',
        lgbName: 'search',
        corporationName: 'search',
        areaType: 'dropdown',
        areaCategory: 'dropdown',
        districtName: 'search',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },
  subcenterMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: subCenterColumns,
      dataKey: 'subcenterId',
      dataName: 'subcenterName',
      filterMethodsConfig: {
        subcenterCode: 'search',
        districtName: 'search',
        status: 'status',
        phcName: 'search',
        talukaName: 'search',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },

  villageMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: villageColumns,
      dataKey: 'villageId',
      dataName: 'villageName',
      filterMethodsConfig: {
        villageCode: 'search',
        villageName: 'search',
        status: 'status',
        subcenterName: 'search',
        phcName: 'search',
        talukaName: 'search',
        districtName: 'search',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },
  subareaMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: subareaColumns,
      dataKey: 'villageId',
      dataName: 'villageName',
      filterMethodsConfig: {
        villageCode: 'search',
        villageName: 'search',
        status: 'status',
        subareaName: 'search',
        phcName: 'search',
        lgbName: 'search',
        talukaName: 'search',
        districtName: 'search',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },

  bankMaster: {
    showAddButton: [],
    showUpdateButton: [],
    showDeleteButton: [],
    tableConfig: {
      columns: bankColumns,
      dataKey: 'bankId',
      dataName: 'bankName',
      filterMethodsConfig: {
        bankCode: 'search',
        bankName: 'search',
        bankBranchName: 'search',
        bankBranchDistrictName: 'search',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },

  bankBranchMaster: {
    showAddButton: [],
    showUpdateButton: [],
    showDeleteButton: [],
    tableConfig: {
      columns: bankBranchColumns,
      dataKey: 'branchId',
      dataName: 'branchName',
      filterMethodsConfig: {
        bankCode: 'search',
        bankName: 'search',
        ifsc: 'search',
        branchName: 'search',
        stateName: 'search',
        districtName: 'search',
        address: 'search',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },

  roleMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: roleColumns,
      dataKey: 'roleId',
      dataName: 'roleName',
      filterMethodsConfig: {
        roleCode: 'search',
        roleName: 'search',
        status: 'status',
        acessLevel: 'search',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },

  userMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: userColumns,
      dataKey: 'userCode',
      dataName: 'userName',
      filterMethodsConfig: {
        firstName: 'search',
        lastName: 'search',
        roleName: 'search',
        userCode:'search',
        status: 'status',
        designation: 'search',
        email: 'search',
        mobileNo: 'search',
        districtName: 'search',
        talukaName: 'search',
        phcName: 'search',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },

  trainingMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: trainingColumns,
      dataKey: 'trainingId',
      dataName: 'trainingName',
      filterMethodsConfig: {
        trainingName: 'search',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },

  facultyMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: facultyColumns,
      dataKey: 'facultyId',
      dataName: 'facultyName',
      filterMethodsConfig: {
        facultyCode: 'search',
        facultyName: 'search',
        districtName: 'search',
        status: 'status',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },

  trainingCalendarMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: trainingCalendarColumns,
      dataKey: 'trainingCalendarId',
      dataName: 'trainingName',
      filterMethodsConfig: {
        facultyName: 'search',
        trainingName: 'search',
        status: 'status',
        recModifiedBy: 'search',
        startDate: 'search',
        days: 'search',
        villageName: 'search',
        subcenterName: 'search',
        phcName: 'search',
        talukaName: 'search',
        districtName: 'search',
      },
      bodyMethods: null,
    },
  },

  programMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: programColumns,
      dataKey: 'programId',
      dataName: 'programName',
      filterMethodsConfig: {
        programCode: 'search',
        programName: 'search',
        status: 'status',
        areaTypeName: 'dropdown',
        recModifiedBy: 'search',
      },
    },
  },

  schemeMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: schemeColumns,
      dataKey: 'schemeId',
      dataName: 'schemeName',
      filterMethodsConfig: {
        schemeCode: 'search',
        schemeName: 'search',
        status: 'status',
        programName: 'search',
        areaType: 'dropdown',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },

  activityMaster: {
    showAddButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    showUpdateButton: [UserRoles.SUPERADMIN],
    showDeleteButton: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
    tableConfig: {
      columns: activityColumns,
      dataKey: 'activityId',
      dataName: 'activityName',
      filterMethodsConfig: {
        activityCode: 'search',
        activityName: 'search',
        status: 'status',
        paymentRate: 'search',
        schemeName: 'search',
        programName: 'search',
        areaType: 'dropdown',
        recModifiedBy: 'search',
      },
      bodyMethods: null,
    },
  },
};
